import type { SectionImage } from '../types';

export const stripLocalImages = (image: SectionImage) => ({
  ...image,
  imageUrl: '',
});
